// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-attribute[data-v-d50fb41a]{padding:1rem}.width-20[data-v-d50fb41a]{width:20%}.width-40[data-v-d50fb41a]{width:40%}.width-15[data-v-d50fb41a]{width:15%}.width-5[data-v-d50fb41a]{width:5%}.icon-size[data-v-d50fb41a]{font-size:1.3em}", ""]);
// Exports
module.exports = exports;
